import './footer.css';
import FooterLogo from './eds.png';
import {Link} from "react-router-dom";

export const Footer = () => {
  return (
      <footer className="snn-footer-wrapper">
        <div className="footer-main-wrapper">
          <div className="snn-footer-logo-wrapper">
            <img src={FooterLogo} alt="Logo" className="top-logo"/>
          </div>
          <div className="footers-links-wrapper">
            <Link to={"/speakers"}><p>Speakers</p></Link>
            <Link to={"/hotels"}><p>Host hotel</p></Link>
            <Link to={"/about"}><p>About</p></Link>
          </div>
          <div>
            <div className="snn-footer-section media">
              <h2 className="snn-section-title snn-margin-top">CONTACT US</h2>
              <p>red.almacenamiento.mx@gmail.com</p>
            </div>
          </div>
          <div>
            <p className="footer-copyright">
              © Energy Storage Discussions, 2025
            </p>
          </div>
        </div>
      </footer>
  );
};
